import api from "@/services/api";


class WarehouseService {

    getWarehouseWithSensorAndRooms(){
        return api.post('/warehouse')
    }

    getWarehouseRooms( warehouseId ){
        return api.post('/warehouse/rooms', {
            warehouseId
        })
    }

    updateRoom(updateData){
        return api.post('/warehouse/room/update', updateData )
    }

    updateWarehouse(updateData){
        return api.post('/warehouse/update', updateData )
    }

    updateRoomMapPicture(formData){
        return api.post('/warehouse/room/map/update', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    updateSensorName(formData){
        return api.post('/warehouse/rooms/sensors/' + formData.id +'/update', formData);
    }

    markerList(controllerId){
        return api.post('/warehouse/rooms/sensors/map/pins',{
            controllerid: controllerId
        })
    }

    addableMarkerList(imei){
        return api.post('/warehouse/rooms/sensors/map/pins/addable', {
            imei: imei
        })
    }

    updateRoomSensorMarkers( data ){
        return api.post('/warehouse/rooms/sensors/save/pins',data)
    }

    removeRoomMarker(sensorId){
        return api.post('/warehouse/rooms/sensors/remove/pins',{
            sensorid: sensorId
        })
    }

    removeRoomPicture(roomId){
        return api.post('/warehouse/room/map/delete', {roomId})
    }

    getWarehouseRoomSensors( roomId ){
        return api.post('/warehouse/rooms/sensors',{
            roomId,
        })
    }

    getAllLastTransmissions(){
        return api.post('/warehouse/LastTransmissions')
    }

    getSensorTemperatureData( sensorId ){
        if (typeof sensorId === "object"){
            return api.post(`/warehouse/rooms/sensors/${sensorId.sensorId}?startDate=${sensorId.start}&endDate=${sensorId.end}&range=${sensorId.range}&alertId=${sensorId.alertId}`)
        }
        return api.post('/warehouse/rooms/sensors/'+sensorId)
    }
}

export default new WarehouseService();